import dayjs from 'dayjs'
import type {UserSettings} from '@package/shared'

export const applyUserSettings = (userSettings: UserSettings) => {
  dayjs.updateLocale(dayjs.locale(), {weekStart: userSettings.firstDayOfWeek})
  dayjs.tz.setDefault(userSettings.timezone)
}
